import React from "react";
import Box from '@mui/material/Box';
import ToolbarMUI from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import SaveIcon from '@mui/icons-material/Save';
import CloseIcon from '@mui/icons-material/Close';
import { useLocation, useNavigate } from "react-router-dom";
import OpenInFullIcon from '@mui/icons-material/OpenInFull';
import Service from '../../../util/Service';
import { AppBar, Button, Divider, FormControl, FormLabel, Grid, Input, InputAdornment, InputLabel, MenuItem, OutlinedInput, Select, Snackbar, Stack, TextField, TextareaAutosize, Toolbar } from '@mui/material';
import EditarPaginaHtml from '../editar/EditarPaginaHtml';

import TipoLayout from './TipoLayout';
import VeryEditorJS from './editorJs/VeryEditorJS';

import { SimpleTreeView, TreeItem } from '@mui/x-tree-view';
import VeryEditor2 from '../../common/EditorVery/VeryEditor2';
import MenuBackupPage from './comps/MenuBackupPage';
import { Rule, Settings } from '@mui/icons-material';
import RulesPopover from "./user/RulesPopover";
import EditarPortalSetting from "./EditarPortalSetting";
import EditarPortalExportComp from "./EditarPortalExportComp";
import PacoteComp from "../../common/PacoteComp";

export default function EditarPortalComp(props) {
    const { fechar, modoEdicao, setModoEdicao, selected } = props;
    const navigate = useNavigate();
    const [html, setHtml] = React.useState('');
    const [blocks, setBlocks] = React.useState({
        time: new Date().getTime(),
        blocks: [],
        version: "2.1.0"
    });
    const [layout, setLayout] = React.useState({});
    const [menu, setMenu] = React.useState();
    const [pagina, setPagina] = React.useState();
    const [pacote, setPacote] = React.useState();
    const [nome, setNome] = React.useState('');
    const [titulo, setTitulo] = React.useState('');
    const [descricao, setDescricao] = React.useState('');
    const [index, setIndex] = React.useState(0)
    const [estilo, setEstilo] = React.useState('')
    const [tipo, setTipo] = React.useState('pagina');
    const [openEditar, setOpenEditar] = React.useState(false);
    const [regra, setRegra] = React.useState('');

    const childRef = React.useRef(null);
    const ref = React.useRef();

    const [openSnackBar, setOpenSnackBar] = React.useState(false);

    const handleClickSnackBar = () => {
        setOpenSnackBar(true);
    };

    const handleCloseSnackBar = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setOpenSnackBar(false);
    };

    React.useEffect(() => {
        if (modoEdicao) {            
            if( selected.id ){
                Service.GET('/api/paginaHtml/buscaPorId/' + selected.id).then(r => {
                    setHtml(r.pagina);
                    setBlocks(r.codigo);
                    setPagina(r);
                    setNome(r.nome);
                    setPacote(r.pacote);
                    setTitulo(r.titulo);
                    setDescricao(r.descricao);
                    setMenu(r.menu);
                    setEstilo(r.estilo);
                    setRegra(r.regra);
                    if (r.index) setIndex(r.index);
                    else setIndex(0);
                    if (r.codigo) setTipo('codigo');
                    if (r.pagina) setTipo('pagina');
                    if (r.menu) setTipo('menu');
                    if (r.layout) {
                        setLayout(r.layout)
                        setTipo('layout');
                    }
                }).catch(er => {
                    console.error(er);
                })
            }else{
                setPacote(selected.pacote);
                setHtml('<html></html>');
            }
        }
    }, [modoEdicao]);


    function onActionEditorJS(r) {
        if (!pagina.codigo.blocks) return;

        let pg = { ...pagina };
        for (let b of pg.codigo.blocks) {
            if (b.type === 'appBar') {
                b.data = r;
            }
        }
        setPagina(pg);
        let dado = { ...pagina }

        dado.nome = nome;
        dado.titulo = titulo;
        dado.descricao = descricao;
        dado.index = index;
        dado.estilo = estilo;
        Service.POST("/api/security/paginaHtml", dado).then(r => {
            console.log(r);
        }).catch(e => {
            alert(e);
        })
    }
    function handleSalva() {
        let dado = { ...pagina }

        dado.nome = nome;
        dado.titulo = titulo;
        dado.descricao = descricao;
        dado.index = index;
        dado.estilo = estilo;

        if (tipo === 'layout') {
            if (childRef) {
                dado.layout = layout;//childRef.current.montaDadoFilho();
            } else {
                console.error('Erro layout')
            }
            delete dado.pagina;
        } else if (tipo === 'pagina') {
            dado.pagina = ref.current.getHtml();
            if( !dado.pagina || dado.pagina.length === 0 ){
                dado.pagina = "<div>A ser definido</div>"
            }            
            setHtml(dado.pagina);
            delete dado.layout;
        }

        if (tipo === 'codigo') {
            delete dado.pagina;
            delete dado.layout;            
            dado.codigo = blocks;
            const item = dado.codigo.blocks.find(i => i.type === 'appBar')
            if (item) {
                // const item2 = old.blocks.find( i => i.type === 'appBar')
                // item.iconColorDark = item2.iconColorDark;
                // item.iconColorLight = item2.iconColorLight
            }
        }
        if (tipo === 'menu') {
            dado.menu = menu;
        }
        dado.regra = regra;
        dado.pacote = pacote;

        Service.POST("/api/security/paginaHtml", dado).then(r => {
            setPagina(r);
            handleClickSnackBar();

        }).catch(e => {
            alert(e);
        })
    }
    function handleUpdatePacote(pk){        
        const dado = {
            id: pagina.id,
            pacote: pk
        }
        Service.POST("/api/security/paginaHtml/salvaPacote", dado).then(ret =>{
            var p = {...pagina};
            p.pacote = pk
            setPagina(p);
        });  
    }
    function handelDoAction(retorno) {
        // setPagina( retorno );
        //setModoEdicao(false);
        // let arr = [...rows];
        // let item = arr.find(i => i.id === pagina.id);
        // if (item) {
        //     item = pagina;
        // }
        // setRows(arr);
    }

    function voltarBackup(pg) {
       
        fechar()
    }
    function handleAddRule(rule) {        
        setRegra(rule.nome)
    }

    return (
        <React.Fragment>
            <AppBar sx={{ position: 'relative', border: '1px solid grey' }} color="transparent"  variant="dense">
                <Toolbar variant="dense">
                    <IconButton
                        edge="start"
                        color="inherit"
                        onClick={fechar}
                        aria-label="close"
                    >
                        <CloseIcon />
                    </IconButton>
                    <Typography sx={{ ml: 2, flex: 1 }} variant="h6" component="div">
                        {nome}
                    </Typography>

                    <Box sx={{ flexGrow: 0 }}>


                        {pagina && <React.Fragment>
                            <EditarPortalExportComp pagina={pagina} />
                            {/* <Divider orientation="vertical" variant="middle" flexItem/> */}
                            <EditarPortalSetting pagina={pagina} />
                        </React.Fragment>}

                        <MenuBackupPage pagina={pagina} action={voltarBackup} />

                        <Tooltip title="Salvar modificações">
                            <IconButton
                                size="large"
                                color="inherit"
                                // onClick={() => setTrigger(!trigger)} sx={{ p: 0 }}
                                onClick={handleSalva}
                            >
                                <SaveIcon />
                            </IconButton>
                        </Tooltip>

                    </Box>
                </Toolbar>
            </AppBar>
            <Box
                sx={{
                    // marginLeft: "10px",
                    // marginRight: "10px",
                    // my: 4,
                    display: "flex",
                    alignItems: "center",
                    // gap: 4,
                    p: 1,
                    // '& .MuiTextField-root': { m: 1, width: '25ch' }
                    // border: '2px solid grey'
                }}>
                <Stack spacing={1} style={{ width: '100%' }}>
                    <Stack direction="row" spacing={1}>
                        <PacoteComp 
                            position="fixo"
                            classeName={nome}
                            pack={pacote}
                            action={handleUpdatePacote}
                            variant="outlined"
                            label="Pacote"
                            style={{
                                width:'500px'
                            }}
                        />
                        <TextField autoFocus
                            label="Nome" variant="outlined" value={nome} 
                            // fullWidth 
                            size="small"
                            onChange={(e) => {
                                setNome(e.target.value);
                            }}
                        />

                        <TextField label="Titulo" variant="outlined" value={titulo} 
                            // fullWidth 
                            size="small"
                            onChange={(e) => {
                                setTitulo(e.target.value);
                            }}
                        />
                    </Stack>
                    <Stack direction="row" spacing={1}>
                        <FormControl style={{width:'300px'}}  >
                            <InputLabel id="demo-simple-select-label">Tipo</InputLabel>
                            <Select size="small"
                                labelId="demo-simple-select-label"
                                id="demo-simple-select"
                                value={tipo}
                                label="Tipo"
                                onChange={(e) => setTipo(e.target.value)}
                            >
                                <MenuItem value={'codigo'}>EditorJS</MenuItem>
                                <MenuItem value={'pagina'}>Pagina</MenuItem>
                                <MenuItem value={'menu'}>Menu</MenuItem>
                                <MenuItem value={'layout'}>Layout</MenuItem>
                            </Select>
                        </FormControl>

                        {tipo != "layout" &&
                            <Stack direction="row" spacing={2}>
                                <TextField size="small"
                                    label="index"
                                    variant="outlined"
                                    // fullWidth
                                    value={index}
                                    onChange={(e) => setIndex(e.target.value.replace(/\D/g, ""))}
                                />
                                <RulesPopover action={handleAddRule} showTxt={true} regra={regra} />
                            </Stack>
                        }
                    </Stack>
                    <FormControl>
                        <FormLabel >Descrição</FormLabel>
                        <TextareaAutosize
                            aria-label="minimum height"
                            minRows={3}
                            placeholder="Descrição minima da pagina"
                            style={{ width: '100%' }}
                            value={descricao ? descricao : ''}
                            onChange={(e) => {
                                setDescricao(e.target.value);
                            }}
                        />
                        <TextField sx={{ mt: 2 }}
                            label="Estilo em linha da pagina"
                            variant="outlined"
                            fullWidth size="small"
                            value={estilo}
                            onChange={(e) => setEstilo(e.target.value)}
                        />
                    </FormControl>
                    {tipo === 'codigo' &&
                        <FormControl>
                            <FormLabel >Código da Pagina</FormLabel>
                            <div style={{
                                position: 'absolute',
                                right: 0,
                                top: 25
                            }}>
                                <Tooltip title="Abrir pagina cheia">
                                    <IconButton
                                        size="small"
                                        color="inherit"
                                        // onClick={() => setTrigger(!trigger)} sx={{ p: 0 }}
                                        onClick={() => {                                            
                                            setOpenEditar(true);
                                        }}
                                    >
                                        <OpenInFullIcon />
                                    </IconButton>
                                </Tooltip>
                            </div>
                            <VeryEditorJS blocks={blocks} setBlocks={setBlocks} action={onActionEditorJS} />
                        </FormControl>
                    }
                    {tipo === 'pagina' &&
                        <FormControl>
                            <FormLabel >Código da Pagina</FormLabel>

                            {modoEdicao && html && <VeryEditor2 html={html} ref={ref} action={
                                <Tooltip title="Abrir pagina cheia">
                                    <IconButton
                                        size="small"
                                        color="inherit"
                                        // onClick={() => setTrigger(!trigger)} sx={{ p: 0 }}
                                        onClick={() => {
                                            navigate("/editarPagina/"+pagina.id, { state: {} });
                                        }}
                                    >
                                        <OpenInFullIcon />
                                    </IconButton>
                                </Tooltip>
                            } />}

                            {!modoEdicao && <VeryEditor2 html={html} ref={ref} action={
                                <Tooltip title="Abrir pagina cheia">
                                    <IconButton
                                        size="small"
                                        color="inherit"
                                        // onClick={() => setTrigger(!trigger)} sx={{ p: 0 }}
                                        onClick={() => {                                            
                                            setOpenEditar(true);
                                        }}
                                    >
                                        <OpenInFullIcon />
                                    </IconButton>
                                </Tooltip>
                            } />}
                        </FormControl>}
                    {tipo === 'menu' &&
                        <EditarMenu menu={menu} setMenu={setMenu} />
                    }
                    {tipo === 'layout' &&
                        <TipoLayout ref={childRef} setLayout={setLayout} layout={layout} />
                    }
                </Stack>
            </Box>
            <EditarPaginaHtml
                open={openEditar} setOpen={setOpenEditar}
                doAction={handelDoAction}
                pagina={pagina}
            />
            <Snackbar
                open={openSnackBar}
                autoHideDuration={5000}
                onClose={handleCloseSnackBar}
                message="Salvo com sucesso"
            />
        </React.Fragment>
    );
}

function EditarMenu(props) { //  blocks={blocks} setBlocks={setBlocks}  pagina={pagina}
    const { menu, setMenu } = props;
    const [itemLable, setItemLable] = React.useState();

    function selectTreeItem(e, label) {
        e.stopPropagation();
        setItemLable(label)
    }

    function montaTreeMenu(menu, index, label) {
        return (
            <TreeItem
                key={index + "_" + label + "_k"}
                itemId={index + "_" + label}
                label={menu.nome}
                onClick={(e) => selectTreeItem(e, label.toString())}
            >
                {menu?.menu && menu?.menu.map((menu, index) => montaTreeMenu(menu, index, label + "." + menu.id))}
            </TreeItem>
        );
    }
    function findMenuItem(data, pathArray) {
        return pathArray.reduce((currentLevel, pathId) => {
            if (!currentLevel || !currentLevel.menu) return null;
            // Converte para número se seus IDs são numéricos
            const id = Number(pathId);
            return currentLevel.menu.find(item => item.id === id);
        }, { menu: data }); // Inicia com um objeto fake que contém a raiz
    }

    function montaEditorMenu() {
        const rotaItem = itemLable ? itemLable?.split('.') : [];
        const selectMenu = findMenuItem(menu, rotaItem)
        const onChangeMenu = (e) => {
            selectMenu[e.target.id] = e.target.value;
            setMenu([...menu]);
        }
        const onChangeRule = (e) => {
            selectMenu[e.target.id] = e.target.value;
            setMenu([...menu]);
        }
        const novoSubMenu = () => {
            if (selectMenu.menu) {
                selectMenu.menu.push({
                    id: (selectMenu.menu.length + 1),
                    nome: "NovoItem" + (selectMenu.menu.length + 1),
                    action: ""
                })
            } else {
                selectMenu.menu = [{
                    id: 1,
                    nome: "NovoItem",
                    action: ""
                }];
            }
            setMenu([...menu]);
        }
        const novoMenu = () => {            
            const newMenu = menu?[...menu]:[];
            newMenu.push({
                id: (newMenu.length + 1),
                nome: "NovoItem" + (newMenu.length + 1),
                action: ""
            })
            setMenu(newMenu);
        }
        const deleteMenu = () => {
            setItemLable()
            setMenu(prevData => {
                const newData = JSON.parse(JSON.stringify(prevData));
                const removeItem = (menu, path, level = 0) => {
                    const currentId = Number(path[level]);
                    for (let i = 0; i < menu.length; i++) {
                        if (menu[i].id === currentId) {
                            if (level === path.length - 1) {
                                menu.splice(i, 1); // Remove o item alvo
                                // Reindexa os itens restantes
                                menu.forEach((item, index) => {
                                    item.id = index + 1; // Novo ID sequencial
                                });
                                return true;
                            }
                            if (menu[i].menu) {
                                return removeItem(menu[i].menu, path, level + 1);
                            }
                        }
                    }
                    return false;
                };
                removeItem(newData, rotaItem);
                return newData;
            });
        }
        const subirItemMenu = () => {
            if (!selectMenu || !rotaItem?.length) return;
            let newRota = [...rotaItem]
            newRota[newRota.length - 1] = (Number(newRota[newRota.length - 1]) - 1)
            const labelRota = newRota.toString().replaceAll(',', '.')
            setItemLable(labelRota.toString())
            setMenu(prevData => {
                const newData = JSON.parse(JSON.stringify(prevData));
                const moveItemUp = (menu, path, level = 0) => {
                    const currentId = Number(path[level]);
                    // Encontra o índice do item atual
                    const currentIndex = menu.findIndex(item => item.id === currentId);
                    // if (currentIndex <= 0) return false; // Já está no topo
                    if (level === path.length - 1) {
                        // Troca a posição com o item anterior
                        [menu[currentIndex - 1], menu[currentIndex]] =
                            [menu[currentIndex], menu[currentIndex - 1]];
                        // Reindexa os IDs
                        menu.forEach((item, idx) => {
                            item.id = idx + 1;
                        });
                        return true;
                    }
                    // Processa recursivamente para submenus
                    if (menu[currentIndex]) {
                        return moveItemUp(menu[currentIndex]?.menu || [], path, level + 1);
                    }
                    return false;
                };
                moveItemUp(newData, rotaItem);
                return newData;
            });
        }

        return (
            <Stack spacing={2} direction="column">
                {itemLable && <TextField
                    id="nome"
                    label={"Menu"}
                    variant="outlined"
                    fullWidth
                    value={selectMenu?.nome || ""}
                    onChange={(e) => onChangeMenu(e)}
                />}
                {itemLable &&
                    <div>
                        <TextField
                            id="action"
                            label={"Action "}
                            variant="outlined"
                            // fullWidth
                            value={selectMenu?.action || ""}
                            onChange={(e) => onChangeMenu(e)}
                        />
                        <FormControl sx={{ ml: 2, width: '25ch' }} variant="outlined">
                            <InputLabel htmlFor="rule">Regra de acesso</InputLabel>
                            <OutlinedInput
                                id="rule"
                                label={"Regra de acesso"}
                                variant="outlined"
                                // fullWidth
                                value={selectMenu?.rule || ""}
                                onChange={(e) => onChangeRule(e)}
                                endAdornment={
                                    <InputAdornment position="end">
                                        <IconButton
                                            aria-label={"Ecolher regra"}
                                            onClick={() => console.log('Não implementado....')}
                                        // onMouseDown={handleMouseDownPassword}
                                        // onMouseUp={handleMouseUpPassword}
                                        >
                                            <Rule />
                                        </IconButton>
                                    </InputAdornment>
                                }
                            />
                        </FormControl>
                    </div>}
                <Stack
                    direction="row"
                    spacing={2}
                    sx={{
                        justifyContent: "center",
                    }}
                >
                    {itemLable && <Button
                        variant="contained"
                        onClick={subirItemMenu}
                        disabled={rotaItem[rotaItem?.length - 1] === '1'}
                    >Subir Item</Button>}
                    {itemLable && <Button
                        variant="contained"
                        onClick={novoSubMenu}
                    // disabled={typeof label !== 'number'}
                    >Novo SubItem</Button>}
                    <Button
                        variant="contained"
                        onClick={novoMenu}
                    >Novo Menu</Button>
                    {itemLable && <Button
                        variant="contained"
                        onClick={deleteMenu}
                        color='error'
                    >Delete</Button>}
                </Stack>
            </Stack>
        )
    }
    return (
        <Grid container spacing={2}>
            <Grid size={12}>
                <AppBar position="static" color="inherit" key={"appBar-2"}>
                    <Box
                        sx={{
                            color: "inherit",
                            flexGrow: 1,
                            display: { xs: 'none', md: 'flex' }
                        }}>
                        {menu && menu?.map((menu) => (
                            <React.Fragment key={menu.id}>
                                {!menu.type && <Button
                                    onClick={() => console.log("<>>>")}
                                    sx={{
                                        my: 2,
                                        // color: darkMode ? 'white' : 'principal',
                                        border: itemLable?.split('.')[0] == menu.id ? '2px solid red' : '',
                                        display: 'block'
                                    }}
                                >
                                    {menu.nome}
                                </Button>}
                                {/* {menu.type === 'dynamic' &&
                                    montaMenuDinamico(menu)
                                } */}
                            </React.Fragment>
                        ))}
                    </Box>
                    <Box sx={{ flexGrow: 1, display: { xs: 'flex', md: 'none' } }}>
                        <Typography variant="subtitle2" noWrap component="div" sx={{ flexGrow: 1, marginTop: 2 }}>
                            Inovação é conquistar os melhores resultados. Isso é Very.
                        </Typography>
                    </Box>
                </AppBar>
            </Grid>
            <Grid size={6}>
                <SimpleTreeView expansionTrigger="iconContainer" >
                    {/* <TreeItem
                        itemId="nome"
                        label="Titulo"
                    // onClick={(e) => selectTreeItem(e, "titulo")}
                    /> */}
                    {menu && menu?.map((menu, index) => montaTreeMenu(menu, index, menu.id))}
                </SimpleTreeView>
            </Grid>
            <Grid size={6}>
                {montaEditorMenu()}
            </Grid>
            <Grid size={6}></Grid>
        </Grid>
    );
}